export default "/images/vendor/@coreui/icons/svg/flag/cif-kz.svg?7ad65ee81df49710799ff5e8d599e665";